import type { QueryClient } from '@tanstack/react-query';
import { applyRealtimeFunnelConversationUpdate } from 'src/modules/shared/communications/utils/cache/funnel-conversations/realtime-update.util';
import type { CommunicationsRealtimeConversationPayload } from '../../types/realtime.types';

/**
 * Applies a validated realtime conversation payload to owned caches.
 *
 * @param queryClient - React Query client that owns the Communications caches.
 * @param payload - Validated conversation realtime payload.
 */
export const applyConversationRealtimePayload = (
  queryClient: QueryClient,
  payload: CommunicationsRealtimeConversationPayload
): void => {
  applyRealtimeFunnelConversationUpdate({
    queryClient,
    funnelConversationId: payload.funnelConversationId,
    action: payload.action,
    conversation: payload.resource,
    document: payload.document,
  });
};
